import {
  Box, TableCell, TableHead, TableRow,
  TableSortLabel
} from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import PropTypes from 'prop-types'
import { TextAlign } from '../TableComissionFilter/EnhancedTableHead'

const headCells = [
  {
    id: 'id_order_platform',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Orden',
    width: '30px'
  },
  {
    id: 'sale_date',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Fecha de venta',
    width: '50px'
  },
  {
    id: 'fulfillment_location',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Lugar de despacho',
    width: '50px'
  },
  {
    id: 'estimated_fulfillment_date',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Fecha estimada de despacho',
    width: '50px'
  },
  {
    id: 'effective_fulfillment_date',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Fecha efectiva de despacho',
    width: '50px'
  },
  {
    id: 'first_delay',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Retraso despacho',
    width: '50px'
  },
  {
    id: 'estimated_arrive_date',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Fecha estimada de recepción',
    width: '50px'
  },
  {
    id: 'arrive_date',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Fecha efectiva de recepción',
    width: '50px'
  },
  {
    id: 'second_delay',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Retraso recepción',
    width: '50px'
  },
  {
    id: 'status',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Estado',
    width: '50px'
  },
  {
    id: 'total_delay',
    align: 'center' as TextAlign,
    disablePadding: false,
    label: 'Retraso total (dias)',
    width: '50px'
  }
]

const EnhancedTableHead = (props : any) => {
  const {
    // onSelectAllClick,
    order,
    orderBy,
    onRequestSort
  } = props
  const createSortHandler = (property : any) => (event : any) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow
        sx={{
          background: 'linear-gradient(to left top, #4676b9, #7c3c91)',
          color: '#ffff',
          padding: 3,
          textAlign: 'center'
        }}
      >
        {headCells.map((headCell: any) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            width={headCell.width}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ color: '#fff', background: 'transparent' }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id
                ? (
                  <Box component='span' sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                  )
                : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
}

export default EnhancedTableHead
